(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Liquid is not rendered in here, so the translated count template arrives
  // as a `data-*` attribute with a %COUNT% sentinel in place of the number.
  //
  // No dependency on window.TerraHogar at all: this element only listens for
  // the `cart:updated` the shared Cart client dispatches, so it neither knows
  // nor cares which deferred script ran first.
  class ThCartCount extends HTMLElement {
    connectedCallback() {
      this.number = this.querySelector('[data-cart-count-number]');
      this.text = this.querySelector('[data-cart-count-text]');
      if (!this.number || !this.text) return;

      this.onCartUpdated = this.render.bind(this);
      document.addEventListener('cart:updated', this.onCartUpdated);
    }

    disconnectedCallback() {
      if (this.onCartUpdated) document.removeEventListener('cart:updated', this.onCartUpdated);
    }

    render(event) {
      const cart = event.detail && event.detail.cart;
      if (!cart || typeof cart.item_count !== 'number') return;

      // Both figures or neither. They are the same fact told twice.
      const count = String(cart.item_count);
      this.number.textContent = count;
      this.text.textContent = String(this.dataset.countTemplate || '').replace('%COUNT%', count);
    }
  }

  if (!customElements.get('th-cart-count')) {
    customElements.define('th-cart-count', ThCartCount);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-nav"]) return;
  try {
    
  // Liquid is not rendered in here. Every translated string is already in the
  // markup this element only unhides.
  function whenThemeReadyForNav(callback) {
    if (window.TerraHogar) {
      callback(window.TerraHogar);
      return;
    }
    document.addEventListener('terrahogar:ready', () => callback(window.TerraHogar), { once: true });
  }

  class ThMainNav extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.main-nav__dialog');
      this.toggle = this.querySelector('[data-nav-dialog-open]');
      if (!this.dialog || !this.toggle) return;

      this.onToggleClick = this.handleToggleClick.bind(this);
      this.toggle.addEventListener('click', this.onToggleClick);

      whenThemeReadyForNav((theme) => this.enhance(theme));
    }

    disconnectedCallback() {
      if (this.toggle && this.onToggleClick) {
        this.toggle.removeEventListener('click', this.onToggleClick);
      }
    }

    // Nothing here happens until window.TerraHogar is real. The <details>
    // baseline stays the drawer for as long as the dialog cannot be opened, and
    // a toggle that is still `hidden` was never a tab stop in the first place.
    enhance(theme) {
      if (!this.isConnected || !theme) return;

      this.toggle.hidden = false;
      this.dataset.dialogEnhanced = 'true';
    }

    handleToggleClick(event) {
      // Lazy lookup rather than the captured `theme`: the shared helper is what
      // adds the background `inert` and the focus restore, and opening the
      // dialog without it would trap a keyboard user in a drawer the page
      // behind is still reachable from.
      const theme = window.TerraHogar;
      if (!theme) return;

      event.preventDefault();
      theme.dialogs.open(this.dialog);
    }
  }

  if (!customElements.get('th-main-nav')) {
    customElements.define('th-main-nav', ThMainNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ThProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.innerHTML.trim().length > 0) return;
      if (!this.dataset.url) return;

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.loadRecommendations();
        },
        { rootMargin: '0px 0px 320px 0px' }
      );
      observer.observe(this);
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const fresh = parsed.querySelector('.product-recommendations');
          if (fresh && fresh.innerHTML.trim().length > 0) {
            this.innerHTML = fresh.innerHTML;
          }
        })
        .catch(() => {});
    }
  }

  if (!customElements.get('th-product-recommendations')) {
    customElements.define('th-product-recommendations', ThProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
